import _regeneratorRuntime from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var __jsx = React.createElement;
import React, { useEffect, useRef } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { fetchProfile, doLogout, reset } from '../login/userSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import styles from '../styles/header/Navbar.module.scss';

var UserTab = function UserTab() {
  var dispatch = useDispatch();
  var user = useSelector(function (state) {
    return state.user;
  });
  var router = useRouter();
  var isMounted = useRef(null);
  useEffect(function () {
    isMounted.current = true;
    var status = user.status == 'idle' ? true : false;

    if (status) {
      dispatch(fetchProfile());
    }

    return function () {
      isMounted.current = false;
    };
  }, []);

  function handleLogout() {
    return _handleLogout.apply(this, arguments);
  }

  function _handleLogout() {
    _handleLogout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var resultAction, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return dispatch(doLogout('logout'));

            case 3:
              resultAction = _context.sent;
              response = unwrapResult(resultAction);

              if (response.status) {
                dispatch(reset());
              }

              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));
    return _handleLogout.apply(this, arguments);
  }

  var userGreeting = __jsx("span", {
    className: "icon-user"
  }, user.firstName != null && user.firstName != '' ? __jsx(React.Fragment, null, __jsx("span", {
    className: "".concat(styles.userInit, " ")
  }, user.firstName[0], user.lastName[0]), " Contul meu") : 'Hello!');

  var goToAccount = function goToAccount() {
    router.push('/');
  };

  var accountOpt = __jsx(DropdownButton, {
    title: userGreeting,
    drop: "down",
    variant: "link",
    menuAlign: "right",
    className: "order-1 order-lg-3 d-none d-md-block green ".concat(styles.dropButton)
  }, __jsx(Dropdown.Item, {
    as: "button",
    onClick: goToAccount
  }, "Contul meu"), __jsx(Dropdown.Divider, null), __jsx(Dropdown.Item, {
    as: "button",
    onClick: handleLogout
  }, __jsx(FontAwesomeIcon, {
    icon: faPowerOff,
    className: "mr-1"
  }), "Logout"));

  var loginOptLabel = __jsx(React.Fragment, null, __jsx(FontAwesomeIcon, {
    icon: faUser,
    className: "mr-0 mr-lg-1"
  }), __jsx("span", {
    className: "d-none d-lg-inline-block"
  }, "Contul meu"));

  var loginOpt = __jsx(DropdownButton, {
    title: loginOptLabel,
    drop: "down",
    variant: "link",
    menuAlign: "right",
    className: "order-1 order-lg-3 green d-none d-md-block ".concat(styles.dropButton)
  }, __jsx(Dropdown.Item, {
    as: "button",
    onClick: goToAccount,
    className: "bg-green"
  }, "Login"), __jsx(Dropdown.Divider, null), __jsx(Dropdown.Item, {
    as: "button",
    onClick: handleLogout
  }, "Cont nou"));

  return user.isLoggedIn ? accountOpt : loginOpt;
};

export default UserTab;